"use client"

import type { ComponentProps } from "react"

import { DockSlot } from "@/components/marketplace/layout/bottom-dock"
import { PdpBuyCta } from "@/components/marketplace/pdp/buy-cta"

interface PdpStickyBuyBarProps extends Omit<ComponentProps<typeof PdpBuyCta>, "docked" | "className"> {
  visible: boolean
  instant?: boolean
}

export const PdpStickyBuyBar = ({ visible, instant, ...cta }: PdpStickyBuyBarProps) => (
  <DockSlot open={visible} instant={instant}>
    <div className="lg:hidden">
      <PdpBuyCta {...cta} docked />
    </div>
  </DockSlot>
)
